import React from "react";
import RefereeInformationCard from "../information_cards/RefereeInformationCard";
import PersonalDetailsCard from "../information_cards/PersonalDetailsCard";
import AcademicDetailsSiwes from "../information_cards/AcademicDetailsSiwes";
import AcademicDetailsIT from "../information_cards/AcademicDetailsIT";
import AcademicDetailsNDE from "../information_cards/AcademicDetailsNDE";
import DocumentUpload from "../information_cards/DocumentUpload";
import CandidateCard from "../information_cards/CandidateCard";
import CommentsCard from "../information_cards/CommentsCard";
import { useGetAllinformationByid } from "../../adapters/Requests";
import { Loader2 } from "lucide-react";

export default function VerificationDetailsViewer({
  applicationId,
  internshipType,
  onActionComplete,
}) {
  let componentToRender;

  const allApplicationInformation = useGetAllinformationByid({
    application_id: applicationId,
  });
  const { data, error, isLoading } = allApplicationInformation;
  const vacancy = data?.vacancy?.id;

  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-10 h-full">
        <Loader2 className="animate-spin text-green-600" size={32} />
      </div>
    );
  }

  if (error) {
    return <div className="p-4 text-red-500">Error: {error.message}</div>;
  }

  switch (internshipType?.toLowerCase()) {
    case "it":
      componentToRender = (
        <AcademicDetailsIT details={data?.ApplicationsAcademicQualification} />
      );
      break;
    case "siwes":
      componentToRender = (
        <AcademicDetailsSiwes
          details={data?.ApplicationsAcademicQualification}
        />
      );
      break;
    case "gap":
      componentToRender = (
        <AcademicDetailsNDE details={data?.ApplicationNYSCDetails} />
      );
      break;
    default:
      componentToRender = <></>;
  }

  return (
    <div className="space-y-5 pb-6 mt-6">
      <CandidateCard applicationId={applicationId} onActionComplete={onActionComplete} />
      {data?.Comments?.length > 0 && <CommentsCard comments={data?.Comments} />}
      <div className="flex flex-col gap-5">
        <div>
          <div className="mb-5">
            <PersonalDetailsCard
              applicant={data.Applicant}
              nextOfKins={data.ApplicationNextOfKins}
            />
            <DocumentUpload
              documents={data?.ApplicationDocuments}
              vacancy={vacancy}
            />
          </div>
        </div>
        <div className="space-y-5">
          {componentToRender}
          {!(internshipType?.toLowerCase() === "siwes") ? (
            <RefereeInformationCard referees={data.ApplicationReferees} />
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}
